<template>
        <b-form
            @submit.prevent="handleSave"
            @keydown="item.onKeydown($event)"
        >
            <b-card-body>
                <b-form-group
                    :label="$t('Name')"
                    label-for="name"
                    :state="item.errors.has('name') ? false : null"
                    :invalid-feedback="item.errors.get('name')"
                >
                    <b-form-input
                        id="name"
                        v-model="item.name"
                        autofocus
                        name="name"
                        :state="item.errors.has('name') ? false : null"
                    />
                </b-form-group>

                <b-form-group
                    :label="$t('Email')"
                    label-for="email"
                    :state="item.errors.has('email') ? false : null"
                    :invalid-feedback="item.errors.get('email')"
                >
                    <b-form-input
                        id="email"
                        v-model="item.email"
                        name="email"
                        :state="item.errors.has('email') ? false : null"
                    />
                </b-form-group>

                <b-form-group
                    :label="$t('Password')"
                    label-for="password"
                    :state="item.errors.has('password') ? false : null"
                    :invalid-feedback="item.errors.get('password')"
                >
                    <b-form-input
                        id="password"
                        v-model="item.password"
                        name="password"
                        :state="item.errors.has('password') ? false : null"
                        type="password"
                    />
                </b-form-group>

                <b-form-group
                    :label="$t('Confirm Password')"
                    label-for="password_confirmation"
                    :state="item.errors.has('password_confirmation') ? false : null "
                    :invalid-feedback="item.errors.get('password_confirmation')"
                >
                    <b-form-input
                        id="password_confirmation"
                        v-model="item.password_confirmation"
                        name="password_confirmation"
                        :state="item.errors.has('password_confirmation') ? false : null"
                        type="password"
                    />
                </b-form-group>

                <b-form-group
                    :label="$t('Role')"
                    label-for="role"
                    :state="item.errors.has('role') ? false : null"
                    :invalid-feedback="item.errors.get('role')"
                >
                    <b-form-select
                        id="role"
                        v-model="item.role"
                        name="role"
                        :options="userRoles"
                        :state="item.errors.has('role') ? false : null"
                    />
                </b-form-group>

                <b-form-group
                    :label="$t('Company')"
                    label-for="company"
                    :state="item.errors.has('company') ? false : null"
                    :invalid-feedback="item.errors.get('company')"
                >
                    <b-form-input
                        id="company"
                        v-model="item.company"
                        name="company"
                        :state="item.errors.has('company') ? false : null"
                    />
                </b-form-group>
            </b-card-body>

            <b-card-footer>
                <b-button
                    v-if="!id || item"
                    :disabled="item.busy"
                    type="submit"
                    variant="primary"
                >
                    {{ id ? $t('Save') : $t('Create') }}
                    <b-spinner v-show="item.busy" small />
                </b-button>
            </b-card-footer>
        </b-form>
</template>

<script>
    import Form from 'vform';
    import {USER_ROLES} from '@/constants';
    import itemMixin from "@/mixins/itemMixin";

    export default {
        name: 'UserOverview',
        mixins: [itemMixin],
        data() {
            return {
                item: new Form({
                    name: null,
                    email: null,
                    password: null,
                    password_confirmation: null,
                    role: USER_ROLES.USER,
                    company: null,
                })
            };
        },
        watch: {
            id(newValue, oldValue) {
                if(!newValue) {
                    this.setData({})
                }
            }
        },
        computed: {
            resourceName() {
                return 'users';
            },
            userRoles() {
                return Object.values(USER_ROLES).map(role => {
                    return {
                        value: role,
                        text: this.$t(role),
                    }
                })

            }
        },
    };
</script>
